/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: eee6fc74c73a
 */

import * as z from "zod";

export type ResponsiveBreakpoint = {
  create_derived?: boolean | undefined;
  max_width?: number | undefined;
  min_width?: number | undefined;
  bytes_step?: number | undefined;
  max_images?: number | undefined;
  transformation?: string | undefined;
};

export const ResponsiveBreakpoint$zodSchema: z.ZodType<ResponsiveBreakpoint> = z
  .object({
    bytes_step: z.int().optional().describe(
      "The minimum byte size difference between consecutive breakpoint images.",
    ),
    create_derived: z.boolean().optional().describe(
      "Whether to generate and store the derived images. Default is true.",
    ),
    max_images: z.int().optional().describe(
      "The maximum number of breakpoint images to generate.",
    ),
    max_width: z.int().optional().describe(
      "The maximum width for responsive breakpoint images.",
    ),
    min_width: z.int().optional().describe(
      "The minimum width for responsive breakpoint images.",
    ),
    transformation: z.string().optional().describe(
      "A transformation string to apply before generating breakpoints.",
    ),
  });
